import React from 'react';
import SignUpPage from './SignUpPage';

const NewPartnerSignUpPage: React.FC = () => {
  return <SignUpPage variant="partner" />;
};

export default NewPartnerSignUpPage;
